<template>
    <div class="error-dialog">
        <v-modal :show="show" :headerVisible="false" :size="'m'">
            <template v-slot:title>
            </template>
            <template v-slot:body>
                <div class="notifit_error_message">
                    <div class="site-menu-icon modal-title-icon modals-icon">
                        <i class="icon-info" aria-hidden="true">
                        </i>
                    </div>
                    <div class="general-nofi-modal-title">
                        {{message}}
                    </div>
                    <slot name="content"></slot>
                </div>
            </template>
            <template v-slot:buttons>
                <p style="text-align:center;">
                    <button class="btn btn-success" @click.prevent="okClicked">OK</button>
                    <button v-if="isCancelBtnVisible" class="btn btn-primary" @click.prevent="cancelClicked">CANCEL</button>
                </p>
            </template>
        </v-modal>
    </div>
</template>

<script>

    export default {
        name: "error-dialog",
        components: {

        },
        props: {
            title: String,
            message: String,
            show: Boolean,
            isCancelBtnVisible: {
                type: Boolean,
                dafault: true,
            }
        },
        methods: {
            okClicked() {
                this.$emit("onClickOk");
            },
            cancelClicked() {
                this.$emit("cancel");
            }
        },
        created() {
            this.$eventBus.$on("v-modal-close", () => this.closeClicked());
            this.$eventBus.$on("v-modal-cancel", () => this.cancelClicked());
        }
    };
</script>

<style>
    .error-dialog .notifit_error_message {
        text-align: center;
    }

    .error-dialog .modal-dialog {
        top: 25% !important;
    }

    .error-dialog .btn-success {
        width: 90px;
    }

    .error-dialog .btn-primary {
        width: 90px;
    }

    .general-nofi-modal-msg {
        margin-top: 25px;
        margin-bottom: -3px;
    }

    .notifit_error_message .site-menu-icon.modal-title-icon {
        color: #F46800 !important;
        font-size: 32px;
    }
</style>


// WEBPACK FOOTER //
// error-dialog.vue?5cf91c49